import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function BuyNowBookLaterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 20.07">
      <path d="M19 1.21h-2V.52a.52.52 0 10-1 0v.69h-4.24V.52a.52.52 0 00-.52-.52.52.52 0 00-.53.52v.69H6.5V.52A.52.52 0 006 0a.52.52 0 00-.53.52v.69H3a3 3 0 00-3 3v12.86a3 3 0 003 3h16a3 3 0 003-3V4.21a3 3 0 00-3-3zm2 15.86a2 2 0 01-2 2H3a2 2 0 01-2-2V6.45h20zM21 5.4H1V4.21a2 2 0 012-2h2.45v1.46a.52.52 0 00.55.52.52.52 0 00.52-.52V2.21h4.21v1.46a.52.52 0 00.53.52.52.52 0 00.52-.52V2.21H16v1.46a.52.52 0 001 0V2.21h2a2 2 0 012 2z"/>
      <path d="M11.5 17.67a5 5 0 10-5-5 5 5 0 005 5zm0-9a4 4 0 11-4 4 4 4 0 014-4z"/>
      <path d="M14 13.17v-1h-2v-2.5h-1v3.5h3z"/>
    </SvgIcon>
  )
}
export default BuyNowBookLaterIcon
